var map = {
	"./angbao-bonus-thaipusam.webp": 2490,
	"./angbao-bonus.webp": 2491,
	"./angbao-bonus_dewali.webp": 2492,
	"./cny-lucky-draw.webp": 2493,
	"./cny-promo.webp": 2494,
	"./dewali-promo.webp": 2495,
	"./fifa-logo.webp": 2496,
	"./fifa-prediction.webp": 2497,
	"./fifa-qna.webp": 2498,
	"./raya-promo.webp": 2499,
	"./welcome-cny-bonus.webp": 2500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2489;